module.exports = __webpack_public_path__ + "img/video-1-tmb.1bbfb296.png";